export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
export const QUESTION_ONE = 'QUESTION_ONE';
export const QUESTION_TWO = 'QUESTION_TWO'; 
export const QUESTION_THREE = 'QUESTION_THREE'; 
export const QUESTION_FOUR = 'QUESTION_FOUR'; 
export const QUESTION_FIVE = 'QUESTION_FIVE'; 